export { default } from "./assignmentPropTypes";
